var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{on:{"click":function($event){return _vm.emitClick()}}},[_c('span',{staticClass:"btn-text"},[_vm._v("Download")])])
}
var staticRenderFns = []

export { render, staticRenderFns }